import { createContext, useContext } from 'react';

export interface ToastState {
  /** Shows a message for a few seconds. A second call while one is showing replaces it. */
  show: (message: string) => void;
}

export const ToastContext = createContext<ToastState | null>(null);

export function useToast(): ToastState {
  const value = useContext(ToastContext);
  if (!value) throw new Error('useToast must be used inside ToastProvider');
  return value;
}
